import React, { PropsWithChildren } from 'react';
import { MaybeNil } from '../../../utils/interfaces';
import styled from 'styled-components';
import { useAliasNavigationSource } from './hooks';
import { GraphQLUserAliasId } from '../../../utils/types';
import { theme } from '../../../styles/theme';

interface IProps {
  aliasId: MaybeNil<GraphQLUserAliasId>;
}

const Container = styled.div`
  &.highlight {
    // Svilen: I can't make it work smoothly

    // @keyframes mainAnimation {
    //   0% {
    //     background-color: highlightColor;
    //   }
    //   62.5% {
    //     background-color: highlightColor;
    //   }
    //   100% {
    //     background-color: unset
    //   }
    // }
    //
    // @keyframes childrenAnimation {
    //   0% {
    //     background-color: transparent;
    //   }
    //   100% {
    //     background-color: unset;
    //   }
    // }
    //
    // animation: mainAnimation 8s;
    //
    // * {
    //   animation: childrenAnimation 8s;
    // }

    @keyframes noAnimation {
      0% {
      }
      100% {
      }
    }
    background-color: ${theme.colors.contentHighlight};
    animation: noAnimation 5s;

    * {
      background-color: transparent;
    }
  }
`;

export const scrollToAliasIdAndHighlight = (node: HTMLElement) => {
  node.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
  node.classList.add('highlight');
  const listener = () => {
    node.classList.remove('highlight');
    node.removeEventListener('animationend', listener);
  };
  node.addEventListener('animationend', listener);
};

export const AliasHighlight = ({
  aliasId,
  children,
}: PropsWithChildren<IProps>) => {
  const { highlightRef } = useAliasNavigationSource(aliasId);
  return <Container ref={highlightRef}>{children}</Container>;
};
